import src from "IMAGE";
export default { src, width: 1042, height: 160, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMZZR//BUj//26mg/9TU1P/c3Nz/29vb/9LS0v/X19f/hBQZcRK02vMAAAAASUVORK5CYII="};
